export default {
  saveState: true,
  filterable: false,
  responseAdapter: function (resp) {
    return {
      data: resp.data.data,
      count: resp.data.meta.pagination.total
    }
  },
  texts: {
    count: 'Dal {from} al {to} di {count} records',
    filter: 'Filter Results:',
    filterPlaceholder: 'Search query',
    limit: 'Record per pagina: ',
    noResults: 'No matching records',
    page: 'Page:',
    // for dropdown pagination filterBy: 'Filter by {column}',
    loading:'Carico i dati....',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
  },
  headings: {
    'created_at': 'Inserito il',
    'actions': ''
  }
}


//////////////////
// WEBPACK FOOTER
// ./config/vuetables.js
// module id = Xs64
// module chunks = 1